import { Component, Input } from '@angular/core';
import {
  BullhornDepartment,
  BullhornPrivateLabelId,
  BullhornUserType,
} from 'bullhorn-user-restrictions-service-lib';
import { FilterState } from './user-restrictions-filter.component';
import { UserRestrictionsFilterComponent } from './user-restrictions-filter.component';

@Component({
  selector: 'app-user-restrictions-panel',
  templateUrl: './user-restrictions-panel.component.html',
  styleUrls: ['./user-restrictions-panel.component.scss'],
  standalone: true,
  imports: [UserRestrictionsFilterComponent],
})
export class UserRestrictionsPanelComponent {
  @Input() userTypeFilterState: FilterState<BullhornUserType> | undefined;
  @Input() departmentFilterState: FilterState<BullhornDepartment> | undefined;
  @Input() privateLabelFilterState: FilterState<BullhornPrivateLabelId> | undefined;
}
